module.exports = __webpack_public_path__ + "img/katie.72719c1f.jpeg";